import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareBacklogRoute: InvariantJiraRoute = {
	name: 'software-backlog',
	path: '/jira/software/projects/:projectKey/boards/:boardId/backlog',
};
